/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://8fhk83e5bj.execute-api.us-east-2.amazonaws.com/kempnile",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://vpkf7lvsxbcg3eoqud43fb5slu.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-mbsvkhppangjfkbflca236rrri",
    "aws_cognito_identity_pool_id": "us-east-2:9228ac40-66ee-4be0-a75b-3cfbcc0323b7",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_jPDNs8gn7",
    "aws_user_pools_web_client_id": "57pokc6vd769rano9toomseiia",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
